import type { SyncStateRepositoryPort, SyncStatus } from '../../domain/ports/SyncPorts.ts';
import type { GetSystemDatabase } from './SqlJsCatalogPullMergeAdapter.ts';

export class SqlJsSyncStateRepository implements SyncStateRepositoryPort {
  constructor(private readonly getDb: GetSystemDatabase) {}

  async getStatus(remoteAvailable: boolean): Promise<SyncStatus> {
    const db = this.getDb();
    if (!db) {
      return { lastPullAt: null, lastError: null, remoteAvailable };
    }
    const stmt = db.prepare(
      `SELECT last_pull_at, last_error FROM sync_meta WHERE id = 1 LIMIT 1`,
    );
    try {
      if (!stmt.step()) {
        return { lastPullAt: null, lastError: null, remoteAvailable };
      }
      const row = stmt.getAsObject() as {
        last_pull_at?: string | null;
        last_error?: string | null;
      };
      return {
        lastPullAt: typeof row.last_pull_at === 'string' ? row.last_pull_at : null,
        lastError: typeof row.last_error === 'string' ? row.last_error : null,
        remoteAvailable,
      };
    } finally {
      stmt.free();
    }
  }

  async recordSuccess(): Promise<void> {
    const db = this.getDb();
    if (!db) return;
    db.run(
      `INSERT INTO sync_meta (id, last_pull_at, last_error, fecha_actualizacion)
       VALUES (1, datetime('now'), NULL, datetime('now'))
       ON CONFLICT(id) DO UPDATE SET
         last_pull_at = excluded.last_pull_at,
         last_error = NULL,
         fecha_actualizacion = datetime('now')`,
    );
  }

  async recordFailure(message: string): Promise<void> {
    const db = this.getDb();
    if (!db) return;
    db.run(
      `UPDATE sync_meta SET last_error = ?, fecha_actualizacion = datetime('now') WHERE id = 1`,
      [message.slice(0, 500)],
    );
  }
}
